var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { StudyVersionStatus } from "healthex-common/study.dtos";
import { observable, reaction, runInAction } from "mobx";
import { IAS_PATH, IAS_UPDATE_PATH } from "../UI/RoutingUIManager";
export class FeatureManager {
    get features() {
        return this._features;
    }
    get hasLoadedFeatures() {
        return this._hasLoadedOnce;
    }
    get isLoading() {
        return this._isLoading;
    }
    hasLoadedFeaturesForStudy(studyId) {
        return !this._isLoading && this._loadedForStudyId === studyId;
    }
    constructor(featureService, routingUIManager, studyService, authManager) {
        this.featureService = featureService;
        this.routingUIManager = routingUIManager;
        this.studyService = studyService;
        this.authManager = authManager;
        this._features = [];
        this._hasLoadedOnce = false;
        this._isLoading = false;
        this._loadedForStudyId = undefined;
        this.currentStudyId = undefined;
        this.currentUserId = undefined;
        reaction(() => this.routingUIManager.currentRoute, () => {
            var _a, _b, _c, _d;
            const userId = this.authManager.id;
            let studyId;
            if (((_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.studyId) === IAS_PATH ||
                ((_b = this.routingUIManager.currentRouteParams) === null || _b === void 0 ? void 0 : _b.studyId) === IAS_UPDATE_PATH) {
                studyId = null;
            }
            else {
                studyId = (_d = (_c = this.routingUIManager.currentRouteParams) === null || _c === void 0 ? void 0 : _c.studyId) !== null && _d !== void 0 ? _d : null;
            }
            if (userId !== this.currentUserId || studyId !== this.currentStudyId) {
                this.currentUserId = userId;
                this.currentStudyId = studyId;
                void this.refreshFeatures();
            }
        }, { fireImmediately: true, name: "FeatureManager_currentRoute" });
    }
    isFeatureEnabled(featureFlag) {
        return this.features.some((f) => f.feature === featureFlag && f.enabled);
    }
    getFeatureConfiguration(featureFlag) {
        var _a, _b;
        return (_b = (_a = this.features.find((f) => f.feature === featureFlag)) === null || _a === void 0 ? void 0 : _a.configuration) !== null && _b !== void 0 ? _b : null;
    }
    getFeature(featureFlag) {
        var _a;
        return (_a = this.features.find((f) => f.feature === featureFlag)) !== null && _a !== void 0 ? _a : null;
    }
    decodeFeatureConfiguration(featureFlag) {
        var _a, _b;
        return (_b = (_a = this.getFeature(featureFlag)) === null || _a === void 0 ? void 0 : _a.decodeConfiguration()) !== null && _b !== void 0 ? _b : null;
    }
    async refreshFeatures() {
        const targetStudyId = this.currentStudyId;
        runInAction(() => {
            this._isLoading = true;
        });
        try {
            let organizationId;
            if (targetStudyId) {
                organizationId = await this.studyService
                    .getStudyPublicInfoById(targetStudyId, StudyVersionStatus.ACTIVE)
                    .then((study) => study === null || study === void 0 ? void 0 : study.addedByOrganization.id);
            }
            let features;
            if (this.currentUserId) {
                features = await this.featureService.getFeaturesForUser(this.currentUserId, organizationId !== null && organizationId !== void 0 ? organizationId : null);
            }
            else if (organizationId) {
                features = await this.featureService.getFeaturesForOrganization(organizationId);
            }
            else {
                features = await this.featureService.getGlobalFeatures();
            }
            runInAction(() => {
                this._features = features;
                this._loadedForStudyId = targetStudyId;
            });
        }
        catch (error) {
            runInAction(() => {
                this._features = [];
                this._loadedForStudyId = targetStudyId;
            });
        }
        finally {
            runInAction(() => {
                this._hasLoadedOnce = true;
                this._isLoading = false;
            });
        }
    }
}
__decorate([
    observable
], FeatureManager.prototype, "_features", void 0);
__decorate([
    observable
], FeatureManager.prototype, "_hasLoadedOnce", void 0);
__decorate([
    observable
], FeatureManager.prototype, "_isLoading", void 0);
__decorate([
    observable
], FeatureManager.prototype, "_loadedForStudyId", void 0);
